// extracted by mini-css-extract-plugin
module.exports = {"label":"ErrorLabel_label__rAziZ"};